export default "__VITE_ASSET__Clw0t$EQ__"